/**
 * Messages between the engine (main thread) and the chime worklet processor.
 * The processor is plain JS (public/worklet/chime-processor.js); these types document
 * the wire format and keep the engine honest.
 */
import type { QualityTier, StrikeKind } from '../types';

export type ChimeMessage =
  | { type: 'strike'; tube: number; velocity: number; s: number; kind: StrikeKind }
  | { type: 'damp'; tube: number; amount: number }
  | { type: 'state'; detune: number[]; damped: number[]; gust: number }
  | { type: 'pan'; pans: number[] }
  | { type: 'reset' };

export interface ChimeProcessorOptions {
  tier: QualityTier;
  /** fundamentals, Hz, index = tube index */
  tuningHz: number[];
  /** partial ratios (physics/geometry BAR_PARTIALS) */
  partials: number[];
  seed: number;
  /** initial constant-power pan per tube, -1..1 (may also be sent later as a 'pan' message) */
  pans?: number[];
  /** wind bed on (default true; headless measurements turn it off) */
  wind?: boolean;
}

export const CHIME_PROCESSOR_NAME = 'discordant-chime';
